import * as React from "react";
import { AppliedFilter } from "../applied_filter/applied_filter";
import { Filter } from "../applied_filter/filter";
import { removePropertyFromFilter } from "../helpers/handle_remove_filter";
import {
  booleanProperty,
  serializedTrueValue,
} from "../helpers/filter_url_serialization";

const filterKey = "freeShipping";
const serializedKey = "dopravaZdarma";
const displayName = "Doprava zdarma";

export const FreeShippingFilter: Filter = {
  key: "freeShipping",
  serialize: (appliedFilter) =>
    appliedFilter[filterKey] === true
      ? booleanProperty(serializedKey, true)
      : null,
  deserialize: (urlSearchParams: URLSearchParams) =>
    urlSearchParams.get(serializedKey) === serializedTrueValue
      ? { freeShipping: true }
      : {},
  AppliedControlComponent: ({ appliedFilter, onRemove }) => {
    if (appliedFilter.freeShipping !== true) {
      return null;
    }
    return (
      <AppliedFilter
        filterName={displayName}
        values={[{ name: "ano" }]}
        onRemove={() =>
          onRemove(removePropertyFromFilter(appliedFilter, filterKey))
        }
      />
    );
  },
};
